import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "relations-card"
};
const _hoisted_2 = {
  style: {
    "font-weight": "normal",
    "font-size": "0.75rem"
  }
};
const _hoisted_3 = {
  style: {
    "font-weight": "normal",
    "font-size": "0.75rem"
  }
};
const _hoisted_4 = {
  class: "relations-position-held"
};
const _hoisted_5 = {
  class: "relations-license"
};
const _hoisted_6 = {
  key: 0,
  class: "relations-is-core"
};
const _hoisted_7 = {
  key: 1,
  class: "relations-not-core"
};
const _hoisted_8 = {
  key: 0,
  class: "relations-is-active"
};
const _hoisted_9 = {
  key: 1,
  class: "relations-not-active"
};
import { ElButton } from 'element-plus';
export default {
  __name: 'WORWORelationsCard',
  props: {
    relation: {
      type: Object,
      required: true
    }
  },
  emits: ['edit-relations'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // functions

    const changeEditMode = () => {
      emits('edit-relations', props.relation);
    };

    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        style: {
          "align-items": "center"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 2
        }, {
          default: _withCtx(() => [_createElementVNode("text", {
            class: _normalizeClass(["role-name", __props.relation.role.nickname && __props.relation.role.nickname.length > 0 ? '' : 'empty-role-name'])
          }, [_createTextVNode(_toDisplayString(__props.relation.role.nickname ?? '雾海游魂') + " ", 1), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", _hoisted_2, " id: " + _toDisplayString(__props.relation.role.id), 1)], 2)]),
          _: 1
        }), _createVNode(_component_el_col, {
          offset: 1,
          span: 2
        }, {
          default: _withCtx(() => [_createElementVNode("text", {
            class: _normalizeClass(["organizations-name", __props.relation.organization.name && __props.relation.organization.name.length > 0 ? '' : 'empty-organizations-name'])
          }, [_createTextVNode(_toDisplayString(__props.relation.organization.name ?? '未在册组织') + " ", 1), _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", _hoisted_3, " id: " + _toDisplayString(__props.relation.organization.id), 1)], 2)]),
          _: 1
        }), _createVNode(_component_el_col, {
          offset: 1,
          span: 2
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_4, " 身份：" + _toDisplayString(__props.relation.position_held && __props.relation.position_held.length > 0 ? __props.relation.position_held : '普通成员'), 1)]),
          _: 1
        }), _createVNode(_component_el_col, {
          offset: 1,
          span: 2
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_5, " 许可等级：" + _toDisplayString(__props.relation.skills_degree_license), 1)]),
          _: 1
        }), _createVNode(_component_el_col, {
          offset: 1,
          span: 2
        }, {
          default: _withCtx(() => [__props.relation.is_core ? (_openBlock(), _createElementBlock("text", _hoisted_6, " 核心组织 ")) : (_openBlock(), _createElementBlock("text", _hoisted_7, " 关联组织 "))]),
          _: 1
        }), _createVNode(_component_el_col, {
          offset: 1,
          span: 2
        }, {
          default: _withCtx(() => [__props.relation.is_active ? (_openBlock(), _createElementBlock("text", _hoisted_8, " 生效 ")) : (_openBlock(), _createElementBlock("text", _hoisted_9, " 失效 "))]),
          _: 1
        }), _createVNode(_component_el_col, {
          offset: 5,
          span: 2
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElButton), {
            onClick: changeEditMode
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 修改关系 ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};